import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

const FOCUSABLE_SELECTOR = 'a[href], area[href], button, input, select, textarea, summary, iframe, [contenteditable], [tabindex]';
 
@Directive({
  selector: '[appExcludeFromTabOrder]',
  standalone: true,
})
export class ExcludeFromTabOrderDirective implements AfterViewInit, OnDestroy {
  private host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private observer?: MutationObserver;

  ngAfterViewInit() {
    this.apply(); 
    this.observer = new MutationObserver(() => this.apply());
    this.observer.observe(this.host, { childList: true, subtree: true });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private apply() {
    this.host.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR).forEach((element) => {
      if (element.getAttribute('tabindex') !== '-1') {
        element.setAttribute('tabindex', '-1');
      }
    });
  }
}
